"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
require("slick-carousel/slick/slick.css");
require("slick-carousel/slick/slick-theme.css");
var _reactUse = require("react-use");
var _EagerGatsbyImage = require("../EagerGatsbyImage/EagerGatsbyImage");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _makeStyles["default"])(function (_ref) {
  var spacing = _ref.spacing,
    palette = _ref.palette;
  return {
    root: {
      height: "100%",
      background: palette.common.white,
      "& .slick-prev": {
        left: spacing(1),
        zIndex: 1
      },
      "& .slick-next": {
        right: spacing(1),
        zIndex: 1
      },
      "& .slick-dots": {
        top: 0,
        bottom: "auto",
        display: "flex!important",
        justifyContent: "center",
        paddingLeft: spacing(2),
        paddingRight: spacing(2),
        "& li": {
          margin: 0,
          width: "30px",
          "& button::before": {
            fontSize: spacing(1.2)
          },
          "&.slick-active": {
            "& button::before": {
              color: palette.common.white
            }
          }
        }
      }
    }
  };
});
function slideSrc(image, useNoneGatsbyImage) {
  if (!image) return "";
  if (typeof image === "string") return image;
  if (!useNoneGatsbyImage) {
    var _image$Image;
    var src = (0, _EagerGatsbyImage.gatsbyImageUrl)(((_image$Image = image.Image) === null || _image$Image === void 0 ? void 0 : _image$Image.localFile) || image.imageFile || image.Image || image);
    if (src) return src;
  }
  return image.path || image.src || "";
}
function Carousel(_ref2) {
  var media = _ref2.media,
    className = _ref2.className,
    useNoneGatsbyImage = _ref2.useNoneGatsbyImage,
    imageLoading = _ref2.imageLoading;
  var _useStyles = useStyles(),
    root = _useStyles.root;
  var items = media || [];
  var srcs = items.map(function (item) {
    return slideSrc(item, useNoneGatsbyImage);
  }).filter(Boolean);
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var prefetched = (0, _react.useRef)(new Set());
  var touchX = (0, _react.useRef)(null);
  (0, _reactUse.useUpdateEffect)(function () {
    setIndex(0);
  }, [media]);
  var prefetch = function prefetch(src) {
    if (!src || prefetched.current.has(src)) return;
    prefetched.current.add(src);
    var img = new Image();
    img.src = src;
  };
  var go = function go(nextIndex, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (srcs.length < 2) return;
    var wrapped = (nextIndex + srcs.length) % srcs.length;
    setIndex(wrapped);
    prefetch(srcs[(wrapped + 1) % srcs.length]);
  };
  var prefetchNext = function prefetchNext() {
    if (srcs.length < 2) return;
    prefetch(srcs[(index + 1) % srcs.length]);
  };
  if (!srcs.length) return null;
  var current = srcs[Math.min(index, srcs.length - 1)];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(className, " ").concat(root),
    onMouseEnter: prefetchNext,
    onFocus: prefetchNext,
    onTouchStart: function onTouchStart(event) {
      touchX.current = event.changedTouches[0].clientX;
      prefetchNext();
    },
    onTouchEnd: function onTouchEnd(event) {
      if (touchX.current == null || event.target.closest("button")) return;
      var delta = event.changedTouches[0].clientX - touchX.current;
      touchX.current = null;
      if (delta > 40) go(index - 1, event);else if (delta < -40) go(index + 1, event);
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: current,
    alt: "Boat carousel image",
    loading: index === 0 ? imageLoading || "lazy" : "eager",
    decoding: "async",
    draggable: false,
    style: {
      width: "100%",
      aspectRatio: "16 / 9",
      objectFit: "cover",
      objectPosition: "bottom",
      display: "block"
    }
  }), srcs.length > 1 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "slick-prev slick-arrow",
    "aria-label": "Previous photo",
    style: {
      display: "block"
    },
    onClick: function onClick(event) {
      return go(index - 1, event);
    }
  }), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "slick-next slick-arrow",
    "aria-label": "Next photo",
    style: {
      display: "block"
    },
    onClick: function onClick(event) {
      return go(index + 1, event);
    }
  }), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "slick-dots"
  }, srcs.map(function (src, dotIndex) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: src + dotIndex,
      className: dotIndex === index ? "slick-active" : undefined
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      "aria-label": "Photo ".concat(dotIndex + 1),
      onClick: function onClick(event) {
        return go(dotIndex, event);
      }
    }));
  }))));
}
var _default = exports["default"] = Carousel;